import React from 'react';
import Grid from 'material-ui/Grid';
import { ListItem } from 'material-ui/List';
import heart from '../../assets/heart.png';
import Grade from '../graphics/Grade';
// import $ from 'jquery';
import styled from 'styled-components';
    // margin-top: ${props => props.ismobile ? 0 : props.wh};
    // height: ${props => props.ismobile ? calc(100vh - 70px) : calc(`${props.wh}` * 0.5 - 70px)};
const Welcome = styled.div`
  position: absolute;
  width: 100%;
  height: 100vh;
  color: #474747;
  background: #FEEDCB;
  bottom: 0;
  transform: translate3d(0, ${props => props.pos }, 0);
  display: ${props => props.show };
  transition: all 1s ease-in-out;
  font-size: 15px;
  font-weight: 400;
  overflow: hidden;
  z-index: 250;
  
  @media (orientation: landscape) {
    width: 50%;
    right: 0;
    height: calc(100% - 80px);
  }
  @media (min-width: 700px) and (orientation: landscape) {
    width: 41.66667%;
  }
  @media (min-width: 960px) and (orientation: landscape) {
    height: calc(100% - 142px);
    bottom: 62px;
  }
  @media (min-width: 1920px) and (orientation: landscape) {
    width: 33.33333%;
  }
  @media (orientation: portrait) {
    bottom: auto;
    top: 0;
  }
  @media (max-width: 599px) and (orientation: portrait) {
    height: calc(100% - 70px);
  }
  @media (min-width: 600px) and (orientation: portrait) {
    height: 50%;
    bottom: 0;
    top: auto;
  }
  .nowcast {
    padding: 0;
    margin: 5px 0;
    align-items: center;

    @media (min-height: 800px) {
      margin: 15px 0;
    }
    &.good {
      margin-right: 15px;
    }
    &.poor {
      margin-left: 15px;
      @media (min-width: 1280px) {
        margin-left: 0;
      }
    }
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (orientation: portrait) {
    height: 100%;
  }
  @media (min-width: 600px) and (orientation: portrait) {
    flex-direction: row;
  }
  @media (min-width: 960px) and (orientation: portrait) {
    height: calc(100% - 200px);
  }
  @media (orientation: landscape) {
    height: 100%;
  }
  @media (min-height: 600px) and (orientation: landscape) {
    height: calc(100% - 100px);
  }
  @media (min-height: 670px) and (orientation: landscape) {
    height: calc(100% - 150px);
  }
  @media (min-height: 770px) and (orientation: landscape) {
    height: calc(100% - 200px);
  }
`;
const Intro = styled.div`
  margin: 20px 10% 0 10%;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.2em;
  
  @media (min-width: 350px) and (orientation: portrait) {
    margin: 20px 12% 0 12%;
  }
  @media (min-width: 400px) and (orientation: portrait) {
    margin: 30px 12% 0 12%;
  }
  @media (min-width: 600px) and (orientation: portrait) {
    margin: 0 6% 0 5%;
    width: 42%;
    height: auto;
  }
  @media (min-width: 960px) and (orientation: portrait) {
    width: 45%;
    margin: 0 5% 20px 5%;
    font-size: 18px;
  }
  @media  (orientation: landscape) {
    margin: 40px 10% 0 10%;
  }
  p {
    margin-bottom: 20px;
  }
`;
const BodyText = styled.div`
  height: 65%;
  position: relative;

  @media (min-height: 700px) and (orientation: portrait) {
    height: 75%;
  }
`;
const Legend = styled.div`
  margin: 0 10% 10px 10%;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2em;

  @media  (orientation: landscape) {
    margin: 0 10% 10px 10%;
    width: 80%;
  }
  @media (min-width: 350px) and (orientation: portrait) {
    margin: 0 12% 10px 12%;
  }
  @media (min-width: 600px) and (orientation: portrait) {
    font-size: 15px;
    width: 37%;
    margin: 0 5% 0 1%;
  }
  @media (min-width: 960px) and (orientation: portrait) {
    font-size: 18px;
    width: 32%;
    margin: 90px 5% 0 5%;
  }
`;
const Title = styled.div`
  margin: 0 0 10px 0;
  font-size: 32px;
  color: #0066FF;
  font-weight: 700;
  line-height: 1em;

  @media (orientation: portrait) {
    font-size: 32px;
  }
  @media (min-width: 350px) and (orientation: portrait) {
    font-size: 42px;
  }
  @media (min-width: 400px) and (orientation: portrait) {
    font-size: 48px;
  }
  @media (min-width: 600px) and (orientation: portrait) {
    font-size: 38px;
  }
  @media (min-width: 768px) and (orientation: portrait) {
    font-size: 46px;
  }
  @media (min-height: 800px) {
    margin: 0 0 15px 0;
  }
  @media (min-width: 768px) and (orientation: landscape) {
    font-size: 42px;
  }
  @media (min-width: 1280px) and (orientation: landscape) {
    font-size: 54px;
  }
`;
const Label = styled.span`
  line-height: 1.2em;
  margin-left: 10px;
`;
const TabsOffset = styled.span`
  height: 40px;
  width: 100%;
  background: #FEEDCB;
`;
const Grades = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 10px;
`;
const Heart = styled.div`
  background-image: url(${heart});
  background-position: center;
  background-size: auto 100%;
  background-repeat-y: no-repeat;
  background-repeat-x: repeat;
  background-color: #FEEDCB;
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 100px;
  display: none;

  @media (min-height: 600px) and (orientation: landscape) {
    display: block;
  }
  @media (min-height: 670px) and (orientation: landscape) {
    height: 150px;
  }
  @media (min-height: 770px) and (orientation: landscape) {
    height: 200px;
  }

  @media (min-width: 960px) and (orientation: portrait) {
    bottom: 62px;
    height: 200px;
  }
`;

const welcome = (props) => {
  var heartPos = (200 - (770 - props.wH)) + 'px';
  return (
    <Welcome pos={props.pos} show={props.show} heartPos={heartPos}>
      <TabsOffset />
      <ContentWrapper>
        <Intro>
          <Title>Welcome <br />Beach Lover.</Title>
          <BodyText>
            <p>We believe that no one should get sick from a day at the beach, and that’s why we’ve created a simple, yet comprehensive tool that lets you search for the latest water quality information at your favorite beach.</p>
            <p>To get started, enter the location of a beach in the search bar or play around with the map to find water quality information for beaches near you.</p>
          </BodyText>
        </Intro>
        <Legend>
          <Grid container spacing={0}>
            <Grid item xs={12} lg={4}>
              <b>NowCast Predictions</b>
              <Grid container spacing={0} justify="center">
                <Grid item xs={6} lg={12}>
                  <ListItem className="nowcast good">
                    <Grade grade="good" />
                    <Label>Good</Label>
                  </ListItem>
                </Grid>
                <Grid item xs={6} lg={12}>
                  <ListItem className="nowcast poor">
                    <Grade grade="poor" />
                    <Label>Poor</Label>
                  </ListItem>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={8}>
              <b>Beach Report Card Grades</b>
              <Grades>
                <div>
                  <Grade grade="A" /><br/>A
                </div>
                <div>
                  <Grade grade="B" /><br/>B
                </div>
                <div>
                  <Grade grade="C" /><br/>C
                </div>
                <div>
                  <Grade grade="D" /><br/>D
                </div>
                <div>
                  <Grade grade="F" /><br/>F
                </div>
              </Grades>
            </Grid>
          </Grid>
        </Legend>
      </ContentWrapper>
      <Heart />
    </Welcome>
  );
}

export default welcome;


// WEBPACK FOOTER //
// ./src/components/static/Welcome.js